/**
 * VP-175: Deep-linki do ekranów Meta, na których user MUSI sam utworzyć zasób —
 * Meta Graph API nie pozwala tworzyć Strony / Portfolio biznesowego / Konta
 * reklamowego programowo dla dowolnego usera. Wizard wykrywa brak, otwiera właściwy
 * ekran Meta i po powrocie ponownie sprawdza stan (auto-detekcja).
 *
 * URL-e mogą z czasem ewoluować po stronie Meta — trzymamy je w jednym miejscu.
 */
export const META_DEEPLINKS = {
  /** Utworzenie nowej Strony na Facebooku. */
  createPage: "https://www.facebook.com/pages/create",
  /** Utworzenie Portfolio biznesowego (Business Managera). */
  createBusiness: "https://business.facebook.com/overview",
  /** Utworzenie / dodanie Konta reklamowego (Ustawienia firmy → Konta reklamowe). */
  createAdAccount: "https://business.facebook.com/settings/ad-accounts",
} as const;
